import type {
  EmailBounceDetailResponse,
  EmailBouncesListBody,
  EmailBouncesListResponse,
} from '@/api/(admin)/email-bounces/types';
import { BACKEND_URL } from '@/lib/constants/api';
import { apiFetch } from '@/lib/utils/apiFetch';

/**
 * Email delivery tracking. Registered under `/system` on the backend rather
 * than `/admin`, but guarded the same way (`hasBearer` + `isAdmin`) and served
 * from the same host — so, like the other management endpoints, the base has to
 * be passed explicitly or the request goes to the api-service and 404s.
 */

/** The roster. A POST because the filters travel in the body, not the query. */
export async function fetchEmailBounces(
  body: EmailBouncesListBody,
): Promise<EmailBouncesListResponse> {
  return apiFetch<EmailBouncesListResponse>(
    '/system/emails/list',
    { method: 'POST', body: JSON.stringify(body) },
    BACKEND_URL,
  );
}

/** One email with its full status history, oldest event first. */
export async function fetchEmailBounce(
  id: string,
): Promise<EmailBounceDetailResponse> {
  return apiFetch<EmailBounceDetailResponse>(
    `/system/emails/${id}`,
    {},
    BACKEND_URL,
  );
}
